module.exports = new __parcel__URL__("resmiclogo.4179cff7.png").toString();